import { defineMessages } from 'react-intl';

const messages = defineMessages({
  embed: {
    id: 'Embed',
    defaultMessage: 'Embed',
  },
  media: {
    id: 'Media',
    defaultMessage: 'Media',
  },
  type: {
    id: 'Type',
    defaultMessage: 'Type',
  },
  audio: {
    id: 'Audio',
    defaultMessage: 'Audio',
  },
  video: {
    id: 'Video',
    defaultMessage: 'Video',
  },
});

export const EmbedBlockSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.embed),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['href', 'type'],
    },
  ],

  properties: {
    href: {
      title: intl.formatMessage(messages.media),
      widget: 'object_browser',
      mode: 'link',
      selectedItemAttrs: ['UID', 'Title'],
    },
    type: {
      title: intl.formatMessage(messages.type),
      choices: [
        ['video', intl.formatMessage(messages.video)],
        ['audio', intl.formatMessage(messages.audio)],
      ],
      default: 'video',
    },
  },
  required: ['href'],
});
